import { PatientPreviewSelfReportedScores } from "~/providers/components/patientPreview/common/selfReportedScores";
import { VERSIONS } from "~/providers/constants";
import { ScoresData } from "~/providers/utils/types/patientPreviewTypes";
import { PreviewSectionLayout } from "../../common/PreviewSectionLayout";
import { SelfReportedScoresTitle } from "./SelfReportedScoresTitle";

interface SelfReportedScoresV2Props {
  scores: ScoresData;
}

export const PatientPreviewSelfReportedScoresV2 = ({
  scores,
}: SelfReportedScoresV2Props) => {
  return (
    <PreviewSectionLayout title={<SelfReportedScoresTitle />}>
      <div className="flex flex-col gap-4 lg:w-3/4">
        <PatientPreviewSelfReportedScores
          scores={scores}
          version={VERSIONS.v2}
        />
      </div>
    </PreviewSectionLayout>
  );
};
